import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { DevExamples, Home, Login, SendMessage } from "./pages";
import EmpedanceMainLayout from "./components/layouts/EmpedanceMainLayout";
import NotFound from "./pages/NotFound";
import ProtectedRoute, { TeamAdminRoute } from "./pages/ProtectedRoute";
import Team from "./pages/team/Team";
import ApiKeys from "./pages/developer/ApiKeys";
import AuthRoute from "./pages/AuthRoute";
import { Toaster } from "sonner";
import { AuthLayout } from "./components";
import Template from "./pages/template/Template";
import Pricing from "./pages/pricing/Pricing";
import Reports from "./pages/reports/Reports";
import Customers from "./pages/customers/Customers";
import Profile from "./pages/profile/Profile";
import AddTemplate from "./pages/template/AddTemplate";
import AddCustomer from "./pages/customers/AddCustomer";
import Onboarding from "./pages/onboarding/Onboarding";
import OnboardingNew from "./pages/onboarding_new/OnboardingNew";
import ScheduledMessages from "./pages/schedule-msg/ScheduledMessages";
import ChatBot from "./pages/chat-bot/ChatBot";
import AddChatBot from "./pages/chat-bot/AddChatBot";
import Wallet from "./pages/wallet/Wallet";
import AddWallet from "./pages/wallet/AddWallet";
import PricingPerMsg from "./pages/pricing/PricingPerMsg";
import AddPricePerMsg from "./pages/pricing/AddPricePerMsg";
import { Gallery } from "./pages/gallery/Gallery";
import AddGalleryImage from "./pages/gallery/AddGalleryImage";
import CompanyList from "./pages/developer/CompanyList";
import RegisterCompany from "./pages/developer/ReisterCompany";
import CompanyDetail from "./pages/developer/CompanyDetail";
import { ApiDocumentation } from "./pages/apiDocumentation/ApiDocumentation";
import TemplateVariables from "./pages/template-variable/TemplateVariables";
import AddTemplateVariables from "./pages/template-variable/AddTemplateVariables";
import SendMessageVariables from "./pages/send-message-variable/SendMessageVariables";
import { AddDB } from "./pages/user-database/AddDB";
import UserDatabase from "./pages/user-database/UserDatabase";
import AIStudio from "./pages/ai-studio/AIStudio";
import AddAIQuery from "./pages/ai-studio/AddAIQuery";
import HomePage from "./website/home/HomePage";
import WebsiteLayout from "./website/layouts/WebsiteLayout";
import { Contact } from "./website/contact/Contact";
import { ApiDocumentationWebsite } from "./website/apiDocumentation/ApiDocumentationWebsite";
import ScrollToTop from "./components/common/ScrollToTop";
import LiveChat from "./pages/live-chat/LiveChat";
import BroadcastDetails from "./pages/broadcasts/BroadcastDetails";
import MetaProfile from "./pages/meta-profile/MetaProfile";
import BroadCasts from "./pages/broadcasts/BroadCasts";

import Studio from "./pages/studio/Studio";
import DesignEditor from "./pages/studio/DesignEditor";

import ConnectWhatsApp from "./pages/whatsapp_onboarding/ConnectWhatsApp";
import BillingAdmin from "./pages/whatsapp_onboarding/BillingAdmin";
import Shopify from "./pages/integrations/shopify/Shopify";
import ZohoCRM from "./pages/integrations/zoho-CMR/Zoho";
import Register from "./pages/login/Register";


function App() {
  return (
    <Router>
      <ScrollToTop />

      <Toaster richColors position="bottom-right" />
      <Routes>
        {/* WEBSITE ROUTES */}
        <Route element={<WebsiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="contact" element={<Contact />} />
          <Route path="docs" element={<ApiDocumentationWebsite />} />
          {/* <Route path="/docs" element={<Docs />} /> */}
        </Route>

        {/* PROTECTED ADMIN ROUTES */}
        <Route path="/admin" element={<ProtectedRoute />}>
          <Route element={<EmpedanceMainLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />

            <Route path="dashboard" element={<Home />} />

            <Route path="live-chat" element={<LiveChat />} />

            <Route path="dev-examples" element={<DevExamples />} />

            <Route path="templates" element={<Template />} />
            <Route path="templates/add" element={<AddTemplate />} />

            <Route path="variables-templates" element={<TemplateVariables />} />
            <Route
              path="variables-templates/add"
              element={<AddTemplateVariables />}
            />

            <Route path="schedule-messages" element={<ScheduledMessages />} />


            <Route path="reports" element={<Reports />} />

            <Route path="customers" element={<Customers />} />
            <Route path="customers/add" element={<AddCustomer />} />
            <Route
              path="customers/edit/:customerId"
              element={<AddCustomer />}
            />

            <Route path="send-message/:mode" element={<SendMessage />} />

            <Route
              path="variables-send-message/:mode"
              element={<SendMessageVariables />}
            />

            <Route path="profile" element={<Profile />} />


            <Route path="chatbot" element={<ChatBot />} />
            <Route path="chatbot/add" element={<AddChatBot />} />
            <Route path="chatbot/edit/:id" element={<AddChatBot />} />

            <Route path="wallet" element={<Wallet />} />

            <Route path="gallery" element={<Gallery />} />
            <Route path="gallery/add" element={<AddGalleryImage />} />


            <Route
              path="/admin/api-documentation"
              element={<ApiDocumentation />}
            />

            <Route path="userDB" element={<UserDatabase />} />
            <Route path="userDB/connect-db" element={<AddDB />} />

            <Route path="ai" element={<AIStudio />} />
            <Route path="ai/queries/add" element={<AddAIQuery />} />

            <Route path="broadcasts" element={<BroadCasts />} />
            <Route path="broadcasts/:id" element={<BroadcastDetails />} />

            <Route path="meta-profile" element={<MetaProfile />} />

            <Route path="studio" element={<Studio />} />
            <Route path="design/:id" element={<DesignEditor />}/>

            {/* owner and org admins only: billing, team, API, WhatsApp number, integrations */}
            <Route element={<TeamAdminRoute />}>
              <Route path="team" element={<Team />} />

              <Route path="pricing" element={<Pricing />} />
              <Route path="pricing/msg" element={<PricingPerMsg />} />
              <Route path="pricing/msg/add" element={<AddPricePerMsg />} />

              <Route path="onboardings" element={<Onboarding />} />
              <Route path="new-onboarding" element={<OnboardingNew />} />

              <Route path="wallet/add" element={<AddWallet />} />
              <Route path="wallet/edit/:customerId" element={<AddWallet />} />

              <Route path="developer/api" element={<ApiKeys />} />
              <Route path="developer/company" element={<CompanyList />} />
              <Route path="developer/company/register" element={<RegisterCompany />} />
              <Route path="developer/company/:id" element={<CompanyDetail />} />

              <Route path="whatsapp/connect" element={<ConnectWhatsApp />} />
              <Route path="whatsapp/billing" element={<BillingAdmin />} />

              <Route path="integrations/shopify" element={<Shopify />} />
              <Route path="integrations/zoho" element={<ZohoCRM />} />
            </Route>

          </Route>
        </Route>

        {/* LOGIN */}
        <Route element={<AuthRoute />}>
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Route>
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
